<template>
  <div class="select-jump-component">
    <p>组件</p>
    <el-select :value="path" @change="change" placeholder="请选择定位组件">
      <el-option
        v-for="(item, i) in list"
        :disabled="item.id === control.curComponent.id"
        :key="item.id"
        :label="item.label + `${i + 1}`"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  inject: ["control"],
  props: {
    path: {
      type: String,
      require: true
    }
  },
  computed: {
    list() {
      return this.control.components.filter(
        item => !["topPosition", "bottomPosition"].includes(item.positionType)
      );
    }
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="less" scoped>
.select-jump-component {
  display: flex;
  align-items: center;
  > p {
    font-size: 12px;
    font-weight: 400;
    margin-right: 10px;
    line-height: 30px;
  }
  /deep/ .el-select {
    flex: 1;
    width: 100%;
    .el-input__inner {
      height: 30px;
      padding: 0 10px;
      border-radius: 0;
      font-size: 12px;
      color: #999999;
    }
    .el-input--medium .el-input__icon {
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectJumpComponent.vue